function buildConfig(baseInfo) {
    let headImgUrl = Array.isArray(baseInfo.image.productImageList) && baseInfo.image.productImageList.length ? baseInfo.image.productImageList[0].imageUrl : '';
    let pValue = new URLSearchParams(location.search).get('p');
    let queryString = '';
    if (pValue) {
        queryString = `?p=${pValue}`;
    }
    return {
        title: baseInfo.productName,
        desc: baseInfo.prdTmpId === 3 ? '我在途牛发现了一个不错的商品，赶快来看看吧。' : '我在途牛找到一个好去处，一起去旅行吧',
        link: window.app_url && window.app_url('') + 'item/' + baseInfo.productId + queryString,
        imgUrl: headImgUrl
    }
}

export function setShareInfoOnWX(baseInfo, shareConfig) {
    let WX = window.WX;
    if (baseInfo || shareConfig) {
        let baseConfig = shareConfig || buildConfig(baseInfo);
        let wxConfig = {
            title: baseConfig.title,
            shareDesc: baseConfig.desc,
            link: baseConfig.link
        };
        if (baseConfig.imgUrl) {
            wxConfig.imgUrl = baseConfig.imgUrl;
        }
        if (WX) {
            WX.shareConfig(wxConfig);
        }
    }
}

export function setShareInfoOnApp(baseInfo, shareConfig) {
    function setContentById (id, attr, value) {
        if (document.getElementById(id) && attr && value) {
            document.getElementById(id)[attr] = value;
        }
    }

    if (baseInfo || shareConfig) {
        let baseConfig = shareConfig || buildConfig(baseInfo);
        if (!document.getElementById('shareTitle')) {
            return;
        }
        setContentById('shareTitle', 'value', baseConfig.title);
        setContentById('shareDesc', 'value', baseConfig.desc);
        setContentById('shareLink', 'value', baseConfig.link);
        setContentById('shareImg', 'src', baseConfig.imgUrl);
        window.location.href = 'tuniuapp://travel/updateWebInfo?main_title=' + encodeURIComponent('产品详情');
    }
}



// WEBPACK FOOTER //
// libs/business/wx.js